import { OrderType } from "@/stores/telegramAlerts";

/**
 * Get human-readable label for order type
 */
export function getOrderTypeLabel(orderType: OrderType): string {
  const labels: Record<OrderType, string> = {
    [OrderType.MARKET]: "Market Execution",
    [OrderType.BUY_LIMIT]: "Buy Limit",
    [OrderType.SELL_LIMIT]: "Sell Limit",
    [OrderType.BUY_STOP]: "Buy Stop",
    [OrderType.SELL_STOP]: "Sell Stop",
    [OrderType.PENDING]: "Pending Order",
  };
  return labels[orderType] || orderType;
}

/**
 * Get short label for order type (for badges)
 */
export function getOrderTypeShortLabel(orderType: OrderType): string {
  const labels: Record<OrderType, string> = {
    [OrderType.MARKET]: "Market",
    [OrderType.BUY_LIMIT]: "Buy Limit",
    [OrderType.SELL_LIMIT]: "Sell Limit",
    [OrderType.BUY_STOP]: "Buy Stop",
    [OrderType.SELL_STOP]: "Sell Stop",
    [OrderType.PENDING]: "Pendiente",
  };
  return labels[orderType] || orderType.toUpperCase();
}

/**
 * Get CSS badge class for order type
 */
export function getOrderTypeBadgeClass(orderType: OrderType): string {
  const classes: Record<OrderType, string> = {
    [OrderType.MARKET]: "bg-blue",
    [OrderType.BUY_LIMIT]: "bg-info",
    [OrderType.SELL_LIMIT]: "bg-pink",
    [OrderType.BUY_STOP]: "bg-indigo",
    [OrderType.SELL_STOP]: "bg-warning",
    [OrderType.PENDING]: "bg-secondary",
  };
  return classes[orderType] || "bg-secondary";
}
